var _module_exports = "<span>Client selected you as preferred expert for this project.</span>\n";;
var path = 'views/flashes/preferred_contractor.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;